import { render, staticRenderFns } from "./MainProjectForm.vue?vue&type=template&id=5bdb4988&scoped=true&"
import script from "./MainProjectForm.vue?vue&type=script&lang=js&"
export * from "./MainProjectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdb4988",
  null
  
)

export default component.exports